module.exports = __webpack_public_path__ + "media/images/pages/who_we_are/img-1-06978c2d22fdb09721c34c3030756f67.png";